import { render, staticRenderFns } from "./logisticsDialog.vue?vue&type=template&id=f69582ca&scoped=true&"
import script from "./logisticsDialog.vue?vue&type=script&lang=js&"
export * from "./logisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDialog.vue?vue&type=style&index=0&id=f69582ca&prod&lang=scss&"
import style1 from "./logisticsDialog.vue?vue&type=style&index=1&id=f69582ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69582ca",
  null
  
)

export default component.exports